import { Middleware } from '@nuxt/types';

const JA_LOCALE_REGEXP = /^\/ja\/?$/;

const jaLocaleToJpRedirectMiddleware: Middleware = (ctx) => {
  if (process.env.isProduction === '0') return; // 本番環境でのみリダイレクトを実行
  const { redirect, route } = ctx;
  const { path } = route;
  if (JA_LOCALE_REGEXP.test(path)) {
    return redirect(302, `/jp/`); // 将来的に ~/ja/ へ統一する可能性ありなので、一時的な移動を示すステータスコードでリダイレクト
  }
};

export default jaLocaleToJpRedirectMiddleware;
